import React, { useState } from "react";

export const CumulativeDefaultCurves: React.FC = () => {
  const [activeView, setActiveView] = useState("Defaults");

  const views = ["Defaults", "Prepayments", "Loss severity"];

  const legendItems = [
    { color: "rgba(0, 212, 255, 0.95)", label: "2025 Q1" },
    { color: "rgba(0, 255, 136, 0.95)", label: "2024 Q4" },
    { color: "rgba(255, 184, 0, 0.95)", label: "2024 Q3" },
  ];

  return (
    <article className="relative p-4 pb-4.5 rounded-[18px] bg-gradient-to-br from-[#22284d] to-[#10142f] border border-[rgba(139,146,176,0.2)] shadow-[0_16px_40px_rgba(0,0,0,0.6)] overflow-hidden">
      <div className="flex items-center justify-between gap-2 mb-2.5">
        <div className="flex flex-col gap-0.5">
          <div className="text-[15px] font-medium tracking-[0.06em] uppercase">
            Cumulative default curves
          </div>
          <div className="text-[11px] text-[#8b92b0]">
            Cumulative default rate by months-on-book for each vintage.
          </div>
        </div>
        <div className="inline-flex p-0.75 rounded-full bg-[rgba(7,9,26,0.9)] border border-[rgba(139,146,176,0.6)] text-[11px] gap-0.75">
          {views.map((view) => (
            <button
              key={view}
              onClick={() => setActiveView(view)}
              className={`border-none rounded-full px-2.5 py-1 bg-transparent cursor-pointer text-[11px] transition-all duration-200 ${
                activeView === view
                  ? "bg-gradient-to-r from-[rgba(0,212,255,0.46)] to-[rgba(139,92,246,0.6)] text-white"
                  : "text-[#8b92b0] hover:bg-[rgba(26,31,58,0.9)] hover:text-white"
              }`}
            >
              {view}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-1.5 rounded-xl bg-gradient-to-b from-[#1f2849] to-[#050716] border border-[rgba(139,146,176,0.35)] p-2.5 pb-3.5 relative overflow-hidden">
        <div className="flex items-center justify-between gap-2.5 mb-1.5 text-[11px] text-[#8b92b0] flex-wrap">
          <div className="flex items-center gap-2.5 flex-wrap">
            {legendItems.map((item) => (
              <span
                key={item.label}
                className="inline-flex items-center gap-0.75"
              >
                <span
                  className="w-2.25 h-2.25 rounded-full mr-1"
                  style={{ background: item.color }}
                />
                {item.label}
              </span>
            ))}
          </div>
          <div>
            Peak defaults (60M): <strong>3.2%</strong>
          </div>
        </div>

        <div
          className="h-[240px] relative overflow-hidden rounded-[10px] animate-grid-on"
          style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
            linear-gradient(to right, rgba(255, 255, 255, 0.04) 1px, transparent 1px)`,
            backgroundSize: "0 0",
          }}
        >
          <div
            className="absolute inset-0 bg-gradient-to-b from-[rgba(0,212,255,0.35)] to-[rgba(0,212,255,0)] opacity-95"
            style={{
              clipPath:
                "polygon(0% 70%, 8% 66%, 16% 64%, 24% 60%, 32% 57%, 40% 54%, 48% 51%, 56% 47%, 64% 44%, 72% 41%, 80% 38%, 88% 35%, 96% 32%, 100% 30%, 100% 100%, 0% 100%)",
            }}
          />
          <div className="absolute inset-0 pointer-events-none">
            <svg
              viewBox="0 0 100 60"
              preserveAspectRatio="none"
              className="w-full h-full"
            >
              {/* 2025 Q1 */}
              <polyline
                fill="none"
                stroke="rgba(0,212,255,0.95)"
                strokeWidth="1.6"
                strokeLinecap="round"
                points="0,56 10,54 20,52 30,49 40,46 50,43 60,40 70,37 80,34 90,32 100,30"
              />
              {/* 2024 Q4 */}
              <polyline
                fill="none"
                stroke="rgba(0,255,136,0.9)"
                strokeWidth="1.3"
                strokeLinecap="round"
                points="0,56 10,55 20,53 30,51 40,48 50,45 60,42 70,40 80,38 90,36 100,35"
              />
              {/* 2024 Q3 */}
              <polyline
                fill="none"
                stroke="rgba(255,184,0,0.95)"
                strokeWidth="1.3"
                strokeDasharray="2 3"
                points="0,56 10,55 20,54 30,52 40,50 50,48 60,46 70,45 80,44 90,43 100,42"
              />
            </svg>
          </div>
        </div>
      </div>
    </article>
  );
};
